import { renderSlot as _renderSlot, createVNode as _createVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a9bc70e0")

_pushScopeId("data-v-a9bc70e0")
const _hoisted_1 = { class: "validate-edit-box" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_button_large = _resolveComponent("icon-button-large")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("label", {
      class: ["edit-box-label", [_ctx.$mq, _ctx.required ? 'required' : '']],
      for: _ctx.id
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 10, ["for"]),
    _createVNode("input", _mergeProps({ id: _ctx.id }, _ctx.$props, {
      type: "text",
      class: _ctx.inputClass,
      disabled: _ctx.readonly,
      value: _ctx.modelValue,
      ref: "focusRef",
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
    }), null, 16, ["id", "disabled", "value"]),
    _createVNode(_component_icon_button_large, {
      class: "number-button",
      icon: "angle-double-left",
      state: "normal",
      onClick: _ctx.onDecreaseHour
    }, null, 8, ["onClick"]),
    _createVNode(_component_icon_button_large, {
      class: "number-button",
      icon: "angle-left",
      state: "normal",
      onClick: _ctx.onDecreaseMinute
    }, null, 8, ["onClick"]),
    _createVNode(_component_icon_button_large, {
      class: "number-button",
      icon: "angle-right",
      state: "normal",
      onClick: _ctx.onIncreaseMinute
    }, null, 8, ["onClick"]),
    _createVNode(_component_icon_button_large, {
      class: "number-button",
      icon: "angle-double-right",
      state: "normal",
      onClick: _ctx.onIncreaseHour
    }, null, 8, ["onClick"])
  ]))
})